import { DrawerHeader } from "@jumbo/components/JumboLayout/style";
import JumboScrollbar from "@jumbo/components/JumboScrollbar";
import JumboVerticalNavbar from "@jumbo/components/JumboVerticalNavbar/JumboVerticalNavbar";
import useJumboLayoutSidebar from "@jumbo/hooks/useJumboLayoutSidebar";
import useJumboLayoutHeader from "@jumbo/hooks/useJumboLayoutHeader";
import useJumboSidebarTheme from "@jumbo/hooks/useJumboSidebarTheme";
import Div from "@jumbo/shared/Div";
import { SIDEBAR_STYLES, SIDEBAR_VIEWS } from "@jumbo/utils/constants/layout";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { IconButton } from "@mui/material";
import Zoom from "@mui/material/Zoom";
import getCollaborationMenus from "app/pages/CollaborationSpace/Collaboration_menus";
import { getTenantName } from "app/utils/tenantUtils";
import Docgen_menus from "app/pages/Docgen/Docgen_menus";
import DRM_menus from "app/pages/DRM/DRM_menus";
import LathropDrmMenus from "app/pages/DRM/LathropDrmMenus";
import IDS_menus from "app/pages/IDS/IDS_menus";
import OA_menus from "app/pages/OA/OA_menus";
import QC_menus from "app/pages/QC_137/QC_menus";
import ADIM_menus from "app/pages/ADIM/ADIM_menus";
import { getFileNumberGeneratorMenus } from "app/pages/fileNumberGenerator/fileNumberGeneratorMenus";
import SuperAdminMenus from "app/pages/superadmin/SuperAdminMenus";
import TenantMenus from "app/pages/tenants/TenantMenus";
import React, { Suspense, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Logo from "../../../../shared/Logo";
import menus from "./menus";
import SidebarSkeleton from "./SidebarSkeleton";
import { axios_tenant } from "../../../../../axios";
import KotMenus from "app/pages/Kot/KotMenus";
import KotClientMenus from "app/pages/Kot/KotClientMenus";
import ArnoldDrmMenus from "app/pages/DRM/ArnoldDRMMenus";


const oaWorkflowTenants = (process.env.REACT_APP_INTERNAL_TENANTS || "trexo-ops")
    .split(",").map(t => t.trim().toLowerCase());

const Sidebar = () => {

    const [menuItems, setMenuItems] = useState(menus);
    const [oaWorkflowRole, setOaWorkflowRole] = useState(null);
    const role = useSelector(state => state.userStore.role); // <-- get role from Redux
    const location = useLocation();
    const navigate = useNavigate();
    const { sidebarOptions, setSidebarOptions } = useJumboLayoutSidebar({ open: false });
    const { headerOptions, setHeaderOptions } = useJumboLayoutHeader({ open: false });
    const { sidebarTheme } = useJumboSidebarTheme();

    const isOaWorkflowTenant = oaWorkflowTenants.includes(getTenantName()?.toLowerCase());

    // Fetch OA workflow role only when logged in and on collaboration-space
    useEffect(() => {
        if (role && location.pathname.includes("/collaboration-space") && isOaWorkflowTenant) {
            axios_tenant.get("/collaboration/workflow/me", { silent: true })
                .then(res => setOaWorkflowRole(res.data.roles || res.data.role))
                .catch(() => setOaWorkflowRole(null));
        }
    }, [role, location.pathname, isOaWorkflowTenant]);

    useEffect(() => {
        ((location.pathname.includes("dashboard") || location.pathname.includes("trexo-chat")) || location.pathname.includes("invite")) && setSidebarOptions({ open: false })
    }, [])

    useEffect(()=>{
        if (location.pathname.includes("dashboard") || location.pathname.includes("trexo-chat") || location.pathname.includes("invite") || location.pathname.includes("data-verification") || location.pathname.includes("trademark-search") ) {
            setSidebarOptions({open: false});
        } else {
            setSidebarOptions({ open: true });
        }

        if (location.pathname.includes("invite")) {
            setHeaderOptions({ hide: true });
        } else {
            setHeaderOptions({ hide: false });
        }

        if (location.pathname.startsWith("/dashboard") || location.pathname.startsWith("/users"))
            setMenuItems(TenantMenus);

        if (location.pathname === '/superadmin/apps' || location.pathname === '/superadmin/tenants')
            setMenuItems(SuperAdminMenus);

        location.pathname === '/drm' && navigate("/drm/audit-result");
        location.pathname === '/qc' && navigate("/qc/file-upload");
        location.pathname === '/ids' && navigate("/ids/ids-ref");
        location.pathname === '/oa' && navigate("/oa/received");
        location.pathname === '/collaboration-space' && navigate("/collaboration-space/my-files");
        location.pathname === "/kot" && navigate("/kot/active-clients");
        if (location.pathname === "/kot/client/new") {
            navigate("/kot/client/new/client-details");
        }

        if (location.pathname.match(/^\/kot\/client\/edit\/([^/]+)$/)) {
            const id = location.pathname.split("/")[4];
            navigate(`/kot/client/edit/${id}/client-details`);
        }



        if (location.pathname.includes("/drm")) {

            if (localStorage.getItem("TENANT_NAME") === "Lathrop GPM") {
                setMenuItems(LathropDrmMenus);

            } 
            
        else if (
            localStorage.getItem("TENANT_NAME")?.toLowerCase().includes("arnold") &&
            localStorage.getItem("TENANT_NAME")?.toLowerCase().includes("porter")
            ) {
                setMenuItems(ArnoldDrmMenus);
                }
            else {
                setMenuItems(DRM_menus);
            }
        }


        if (location.pathname.includes("/qc"))
            setMenuItems(QC_menus);

        if (location.pathname.includes("/ids"))
            setMenuItems(IDS_menus);

        if (location.pathname.includes("/oa") || location.pathname.includes("/task-manager"))
            setMenuItems(OA_menus);

        if (location.pathname.includes("/adim"))
            setMenuItems(ADIM_menus);

        if (location.pathname.includes("/docgen")) {
            const customFormAccess = localStorage.getItem("TENANT_ROLE") == "admin" ? true : false;
            const isAdmin = getTenantName()?.toLowerCase().includes("admin");
            if (isAdmin) {
                setMenuItems(Docgen_menus);
            } else {
                let modifiedMenu;
                if (!customFormAccess) {
                    modifiedMenu = Docgen_menus.map(menu => {
                        return { label: menu.label, type: menu.type, children: menu?.children.filter(child => child.label != "sidebar.menuItem.docgen_import") };
                    });
                } else {
                    modifiedMenu = Docgen_menus.map(menu => {
                        if (menu.children) {
                            return {
                                ...menu,
                                children: menu.children.map(child => {
                                    if (child.label === "sidebar.menuItem.docgen_import") {
                                        return {
                                            ...child,
                                            children: child.children.filter(
                                                subChild => subChild.label !== "sidebar.menuItem.docgen_import_docket"
                                            )
                                        };
                                    }
                                    return child;
                                })
                            };
                        }
                        return menu;
                    });
                }
                setMenuItems(modifiedMenu);
            }
        }


        if (location.pathname.includes("/collaboration-space"))
            setMenuItems(getCollaborationMenus(oaWorkflowRole));

        if (location.pathname.includes("/file-number-generator"))
            setMenuItems(getFileNumberGeneratorMenus(role));

        if (location.pathname.includes("/kot/client/new")) {
            setMenuItems(KotClientMenus("/kot/client/new"));
        }
        else if (location.pathname.includes("/kot/client/edit")) {
            const id = location.pathname.split("/")[4];
            setMenuItems(KotClientMenus(`/kot/client/edit/${id}`));
        }
        else if (location.pathname.startsWith("/kot")) {
            setMenuItems(KotMenus);
        }

    }, [location.pathname, role, oaWorkflowRole]);


    const SidebarHeader = () => {


        const location = useLocation();

        // location.pathname.includes("dashboard") && setSidebarOptions({open: false})

        useEffect(() => {

        }, [location.pathname])

        const isMiniAndClosed = React.useMemo(() => {
            return sidebarOptions?.view === SIDEBAR_VIEWS.MINI && !sidebarOptions?.open;
        }, [sidebarOptions.view, sidebarOptions.open]);

        const handleSidebarClick = () => {

            !location.pathname.includes("dashboard") && setSidebarOptions({ open: false })
        }


        return (
            <React.Fragment>
                {
                    sidebarOptions?.style !== SIDEBAR_STYLES.CLIPPED_UNDER_HEADER &&
                    <DrawerHeader>
                        <Logo mini={isMiniAndClosed} mode={sidebarTheme.type} />
                        {
                            sidebarOptions?.view !== SIDEBAR_VIEWS.MINI &&
                            <Zoom in={sidebarOptions?.open}>
                                <IconButton
                                    edge="start"
                                    color="inherit"
                                    aria-label="open drawer"
                                    sx={{ ml: 0, mr: -1.5 }}
                                    onClick={handleSidebarClick}
                                >
                                    <MenuOpenIcon />
                                </IconButton>
                            </Zoom>
                        }
                    </DrawerHeader>
                }
            </React.Fragment>
        )
    };


    return (
        <React.Fragment>
            <SidebarHeader />
            <JumboScrollbar
                autoHide
                autoHideDuration={200}
                autoHideTimeout={500}
            >
                <Suspense
                    fallback={
                        <Div
                            sx={{
                                display: 'flex',
                                minWidth: 0,
                                alignItems: 'center',
                                alignContent: 'center',
                                px: 3
                            }}
                        >
                            <SidebarSkeleton />
                        </Div>
                    }
                >
                    <JumboVerticalNavbar translate items={menuItems} />
                </Suspense>
            </JumboScrollbar>
        </React.Fragment>
    );
};



export default Sidebar;